import React, { useContext, useEffect, useState } from 'react';
import { Table, Button, Layout, Typography, Breadcrumb, message } from "antd";
import { OpenRequest } from '../../../core/interfaces/OpenRequest';
import { fetchOpenRequestsData } from '../../../core/services/account-request.service';
import { UserContext } from '../../../context/user-context';
import { statusDescriptions } from '../../../utilities/constants';
import { format } from "date-fns";
import { Link, useNavigate } from "react-router-dom";
import { CalClient } from '@cvx/cal';
import { environment } from '../../../environments/environment';
import { appInsights } from "../../../core/services/insight.service";
import GlobalErrorMessage from '../../global-error/GlobalErrorMessage';


const OpenRequests: React.FC = () => {

     useEffect(() => {}, []);
  const [OpenRequests, setOpenRequests] = useState<OpenRequest[]>([]);
  const [userEmail, setUserEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [graphUser, setGraphUser] = useState<any>({});
  const cal = new CalClient(environment.calConfig);
  const user = useContext(UserContext);
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  

  const getStatusDescription = (status: number): string => {
    return statusDescriptions[status] || "Unknown Status";
  };
  
  const handleRequestIdClick = (requestID: string, status: number, type: string) => {
    const contextValue = {
      requestNumber: requestID,
      reqType: type=="ACC"?"1":"2",
      status: status.toString(),
      frompending : false,
      userEmail: user.email,
    };
    navigate(`/manage requests/request-detail?requestNumber=${contextValue.requestNumber}&reqType=${contextValue.reqType}&frompending=${contextValue.frompending}&userEmail=${contextValue.userEmail}`);
  };

  const columns = [
   {
     title: 'Request ID',
     dataIndex: 'requestID',
     key: 'requestID',
     width: 250,
     render: (requestID: string, record: { status: number; type: string }) => (
      <Button
        type="link"
        onClick={() => handleRequestIdClick(requestID, record.status, record.type)}
        style={{
          padding: 0,
          color: "blue",
          textDecoration: "underline",
        }}
      >
        {requestID}
      </Button>
    ),
  },
   {
         title: "Request Date",
         dataIndex: "requestDate",
         key: "requestDate",
         width: 100,
         render: (date: string) => format(new Date(date), "M/d/yyyy"), // Format the date
       },
   {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 250,
      render: (status: number) => getStatusDescription(status),
    },
   {
     title: 'Waiting On',
     dataIndex: 'pendingOn',
     key: 'pendingOn',
     width: 200,
     className: 'person',
     render: (pendingOn: string) => pendingOn || 'N/A',
   },
 ];
  const getUserEmail = async () => {
   try {
      const response = await cal.getUserPropertiesFromMsGraph([
        "userPrincipalName"
      ]);
      setGraphUser((prev: any) => ({ ...prev, ...user }));
      setGraphUser((prev: any) => ({ ...prev, Emaild: response.userPrincipalName }));
      setUserEmail(response.userPrincipalName);
    } catch (error) {
      setApiError(error);
      console.error("Error fetching user email:", error);
      appInsights.trackEvent({ name: "GetUserEmailFailed", properties: { error: error } });
    }
  };

  const fetchOpenRequests = async (email:string) => {
    setLoading(true);
    try {
      const response = await fetchOpenRequestsData(email);
       // Adjust the API endpoint as needed
      setOpenRequests(response);
    } catch (error) {
      setApiError(error);
      message.error("Failed to fetch open requests");
      appInsights.trackEvent({ name: "GetOpenRequestsFailed", properties: { error: error } });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
   const fetchData = async () => {
     await getUserEmail();
   };
   fetchData();
 }, []);

 useEffect(() => {
   if (userEmail) {
     fetchOpenRequests(userEmail);
   }
 }, [userEmail]);
 const handleRetry = () => {
  setApiError(null);
};
  return (
   <>
     <Breadcrumb
       items={[
         {
           title: "manage requests",
         },
         {
           title: "my open requests",
         },
       ]}
     />
      {apiError ? (
          <GlobalErrorMessage 
          error={apiError}
          visible={!!apiError}
          onClose={() => setApiError(null)}
          onRetry={handleRetry}
        />
        ) : (
     <><div className="div-container">
            <Table
              dataSource={OpenRequests}
              columns={columns}
              rowKey="RequestID"
              loading={loading}
              bordered={true}
              size="small"
              rowClassName={() => "white-background-row"}
              style={{ marginTop: "30px" }} />
          </div><Button
            type="default"
            style={{ marginLeft: "10px" }}
            onClick={() => window.history.back()}
          >
              Back
            </Button></>
        )}
   </>
 );
};

export default OpenRequests;
